import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { getPlatformInfo } from '@/sections/MyShipments/utils';

import PairTitle from './PairTitle';

interface OrderAdditional {
  orderPrice: number;
  cashOnDelivery?: number;
  insured?: number;
}

interface OrderDataBase {
  additional: OrderAdditional;
  trackingId: string;
  platform?: string;
}

interface PriceSectionProps {
  orderData?: OrderDataBase;
  isFFOrder?: boolean;
  countriesWithOutPrices: string[];
  country?: string;
}

const PriceSection = ({
  orderData,
  isFFOrder,
  countriesWithOutPrices,
  country,
}: PriceSectionProps) => {
  const theme = useTheme();

  const priceItems = [
    {
      title: 'Costo de orden',
      value: orderData?.additional.orderPrice.toFixed(2) ?? '0',
      isPrice: true,
    },
    {
      title: 'COD',
      value: orderData?.additional.cashOnDelivery?.toFixed(2) ?? '0',
      isPrice: true,
    },
    {
      title: 'Seguro',
      value: orderData?.additional.insured?.toFixed(2) ?? '0',
      isPrice: true,
    },
  ];

  if (countriesWithOutPrices.includes(country!)) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: '2rem' }}>
      {priceItems.map((item, index) =>
        isFFOrder && (index === 0 || index === 2) ? null : (
          <Grid key={index} size={{ xxs: 12, md: 4 }}>
            <PairTitle {...item} />
          </Grid>
        ),
      )}
      {!isFFOrder && (
        <Grid size={{ xxs: 12, md: 4 }}>
          <PairTitle
            title="Plataforma"
            children={(() => {
              const platformInfo = getPlatformInfo(orderData?.platform);

              if (!platformInfo) {
                return (
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', color: theme.palette.grey[400], fontStyle: 'italic' }}
                  >
                    -
                  </Typography>
                );
              }

              if (!platformInfo.logo) {
                return (
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}
                  >
                    {platformInfo.platform}
                  </Typography>
                );
              }

              return <img src={platformInfo.logo} width={80} alt={platformInfo.platform} />;
            })()}
          />
        </Grid>
      )}
    </Box>
  );
};

export default PriceSection;
